import TablaPaginada from "components/comun/TablaPaginada";
import React from "react";
import { Link } from "react-router-dom";
import {  Card, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from "reactstrap";

const ListCentros = (props) => {
  const cabecera = (
    <>
      <th scope="col">Centros</th>
      <th scope="col">Action</th>
    </>
  );

  const datos = (
    <>
      {props.centros.map((centro) => (
        <tr key={centro.id}>
          <td>{centro.nombre}</td>
          <td >
          <UncontrolledDropdown>
              <DropdownToggle
                className="btn-icon-only"
                href=""
                role="button"
                size="sm"
                color=""
                onClick={(e) => e.preventDefault()}
              >
                <i className="fas fa-ellipsis-v" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
         
                <Link to={`/admin/centros/centro/${centro.id}`}>
                  <DropdownItem
                  >
                    Editar
                  </DropdownItem>
                </Link>
              
               
              </DropdownMenu>
            </UncontrolledDropdown>

          </td>
        </tr>
      ))}
    </>
  );

  return (
    <>
      <Card className="shadow">
        <CardHeader className="border-0">
          <Row>
            <Col>
              <h3 className="mb-0">Centros: </h3>
            </Col>
            <Col className="text-right">
              {" "}
              <Link className="btn btn-primary" to="add">
                Añadir
              </Link>
            </Col>
          </Row>
        </CardHeader>
        <TablaPaginada
          cabecera={cabecera}
          datos={datos}
          currentPage={props.currentPage}
          totalPage={props.totalPage}
          setCurrentPage={props.setCurrentPage}
        ></TablaPaginada>
      </Card>
    </>
  );
};

export default ListCentros;

